export const strict = false

export const state = () => {
	return {
		auth: null,
		smallMenu: false,
		lockMenu: false,
	}
}

export const actions = {
	callCommitAuth({ commit }, token) {
		commit('setAuth', token)
		navigateTo('/home')
	},

	callCommitAuthLogout({ commit }, data) {
		commit('setAuth', data)
	},

	commitSizeMenu({ commit }, { isSmall }) {
		commit('setSmallMenu', isSmall)
	},
}

export const getters = {
	companyId: (state) => {
		if (state.auth) {
			return state.auth.id
		}
		return null
	},
}

export const mutations = {
	setAuth(state, auth) {
		state.auth = auth
	},

	setSmallMenu(state, smallMenu) {
		state.smallMenu = smallMenu
	},

	setLockMenu(state, lockMenu) {
		state.lockMenu = lockMenu
	},

	setAuthId(state, id) {
		state.auth.id = id
	},
}
